if (!window.__lBundleCartInit) {
	window.__lBundleCartInit = true

	let pruning = false
	async function pruneOrphanBundles() {
		if (pruning) return
		pruning = true
		try {
			const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json())
			const groups = {}
			cart.items.forEach((line, idx) => {
				const id = line.properties && line.properties._bundle_id
				if (!id) return
				const size = parseInt((line.properties && line.properties._bundle_size) || '0', 10)
				if (!groups[id]) groups[id] = { size, idxs: [] }
				groups[id].idxs.push(idx)
			})
			const updates = cart.items.map((i) => i.quantity)
			let dirty = false
			for (const g of Object.values(groups)) {
				if (g.size > 0 && g.idxs.length < g.size) {
					g.idxs.forEach((i) => { updates[i] = 0 })
					dirty = true
				}
			}
			if (!dirty) return
			await fetch('/cart/update.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ updates }),
			}).then((r) => r.json())
			if (window.T4SThemeSP?.Cart?.getToFetch) window.T4SThemeSP.Cart.getToFetch(false)
		} catch (err) {
			console.error('Bundle prune failed', err)
		} finally {
			pruning = false
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', pruneOrphanBundles, { once: true })
	} else {
		pruneOrphanBundles()
	}

	async function bundleCartUpdate(group, delta) {
		const lineEls = group.querySelectorAll('[data-bundle-line-key]')
		if (!lineEls.length) return

		// ── Start loading (mirrors changeFetchItem) ──────────────
		const wrapper = group.closest('[data-cart-wrapper]')
		const bar = group.querySelector('.t4s-cart-ld__bar')
		const spinner = bar ? bar.querySelector('.t4s-cart-spinner') : null

		if (wrapper) wrapper.classList.add('is--contentUpdate')
		group.classList.add('is--update')
		if (bar) { bar.removeAttribute('hidden'); bar.classList.remove('t4s-dn') }
		if (spinner) spinner.removeAttribute('hidden')

		// ── Clear loading on cart:updated (mirrors changeFetchItem) ──
		const $ = window.jQuery || window.$
		if ($) {
			$(document).one('cart:updated', () => {
				if (wrapper) wrapper.classList.remove('is--contentUpdate')
			})
		} else {
			document.addEventListener('cart:update:count', () => {
				if (wrapper) wrapper.classList.remove('is--contentUpdate')
			}, { once: true })
		}

		// ── Perform update ───────────────────────────────────────
		try {
			const cart = await fetch('/cart.js').then((r) => r.json())
			const updates = cart.items.map((item) => item.quantity)

			lineEls.forEach((el) => {
				const key = el.dataset.bundleLineKey
				const idx = cart.items.findIndex((item) => item.key === key)
				if (idx !== -1) {
					updates[idx] = delta === null ? 0 : Math.max(0, cart.items[idx].quantity + delta)
				}
			})

			await fetch('/cart/update.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ updates }),
			}).then((r) => r.json())

			if (window.T4SThemeSP?.Cart?.getToFetch) {
				window.T4SThemeSP.Cart.getToFetch(false)
			}
		} catch (err) {
			console.error('Bundle cart update failed', err)
			if (wrapper) wrapper.classList.remove('is--contentUpdate')
		}
	}

	document.addEventListener('click', (e) => {
		const btn = e.target.closest('[data-bundle-plus],[data-bundle-minus],[data-bundle-remove]')
		if (!btn || btn.disabled) return
		e.preventDefault()
		e.stopPropagation()

		const group = btn.closest('[data-bundle-group]')
		if (!group) return

		const delta = btn.hasAttribute('data-bundle-remove')
			? null
			: btn.hasAttribute('data-bundle-plus')
			? 1
			: -1

		group.querySelectorAll('[data-bundle-plus],[data-bundle-minus],[data-bundle-remove]').forEach((b) => {
			b.disabled = true
		})

		bundleCartUpdate(group, delta)
	})
}
